<template>
  <div class="error-layout">
    <p class="error-layout__message content">
      {{ message }}
    </p>
    <b-button v-if="retryLabel && retryFn" type="is-primary" @click="retryFn">
      {{ retryLabel }}
    </b-button>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true
    },
    retryLabel: {
      type: String,
      default: 'Try Again'
    },
    retryFn: Function
  }
};
</script>

<style lang="scss" scoped>
.error-layout {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  height: 100%;

  &__message {
    margin-bottom: 1rem;
  }
}
</style>
